import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next } from "react-i18next";
import arTranslation from './ar/ar.json';
import enTranslation from './en/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      ar: {
        translation: arTranslation
      }
    },
    fallbackLng: "en",

    interpolation: {
      escapeValue: false 
    },
    detection:{
      order: ['localStorage','cookie', 'htmlTag', 'path', 'subdomain'],
      caches:['localStorage']
    }
  });
  export default i18n;